<template>
    <modal
        max-width="600"
        v-model="show"
        @input="onInput"
        :has-padding="false"
        content-class="login-type-add-form modal-device"
    >
        <app-button
            v-if="!noActivator"
            class="btn btn-round btn-primary"
            slot="activator"
            v-tooltip.right="
                !this.canCreateCaptiveForm
                    ? $t('message.generics.message.funcionalityNotActive')
                    : ''
            "
            :disabled="!canCreateCaptiveForm"
            :allowed="!!canCreateCaptiveForm"
            label="Criar Formulário de Login"
            :primary="canCreateCaptiveForm"
            @click="openModal"
        >
        </app-button>

        <div class="login-type-add-form-body">
            <captive-forms-modal-nav-tabs
                data-padding="5px 50px 0 5px"
                v-model="tab"
                :data-tabs="tabs"
                class="nav-tabs"
                :is-edit="isEdit"
                @back="emitBack"
            ></captive-forms-modal-nav-tabs>

            <captive-forms-modal-general
                ref="body"
                :item="item"
                :integrationsList="integrationsList"
                :externalServicesList="externalServicesList"
                :vouchersList="vouchersList"
                :active-directory-list="activeDirectoryList"
                :google-list="googleList"
                :gov-br-list="govBrList"
                :billing-list="billingList"
                v-model="form"
                v-show="isGeneralTab && !isSocialLogin"
                @valid="save"
                @to-general-tab="tab = tabs[0]"
                @input="setFormData"
            />

            <captive-forms-modal-local-tree
                v-if="isLocalsTab"
                :locals="locals"
                :item="item"
                @select="addLocal"
                @deselect="removeLocal"
                v-model="form.locals"
            />

            <captive-forms-modal-extra-fields
                v-if="isExtraFieldsTab"
                :captiveLoginTypeId="captiveLoginTypeId"
            />

            <v-card-actions class="login-type-add-form-body-actions">
                <button
                    class="btn btn-extra-round btn-primary"
                    @click="$refs.body.validate()"
                >
                    {{ actionLabel }}
                </button>
            </v-card-actions>
        </div>
    </modal>
</template>

<script>
import CaptiveFormsModalNavTabs from "./nav-tabs/CaptiveFormsModalNavTabs.vue";
import CaptiveFormsModalGeneral from "./general/CaptiveFormsModalGeneral.vue";
import CaptiveFormsModalLocalTree from "./local-tree/CaptiveFormsModalLocalTree.vue";
import CaptiveFormsModalExtraFields from "./extra-fields/CaptiveFormsModalExtraFields.vue";
import EventBus from "@packages/event-bus";
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";

export default {
    components: {
        CaptiveFormsModalNavTabs,
        CaptiveFormsModalGeneral,
        CaptiveFormsModalLocalTree,
        CaptiveFormsModalExtraFields,
        Modal,
        AppButton,
    },
    data() {
        return {
            show: false,
            page: 0,
            form: {
                id: undefined,
                name: undefined,
                loginButtonLabel: undefined,
                type: undefined,
                isDefault: false,
                integrationId: undefined,
                externalServiceId: undefined,
                segmentVoucherId: undefined,
                locals: [],
                timeoutUnit: null,
                timeoutValue: undefined,
                isValidatePhoneNumber: false,
                isValidateEmail: false,
                vlan: undefined,
                ssidFilter: [],
                allSsidSelected: true,
            },
            tab: {
                value: "GENERAL",
                label: this.$t("message.generics.message.general"),
                disabled: this.isGeneralTabDisabled,
            },
            isExternalServicesTabDisabled: true,
            isLocalTabDisabled: true,
            isGeneralTabDisabled: false,
            isExtraFieldsTabDisabled: true,
            localsLoaded: false,
            locals: [],
            loginTypeLocals: [],
            isOpenArray: [],
            itemLogin: {},
            loginTypeId: undefined,
            integrationsList: [],
            externalServicesList: [],
            vouchersList: [],
            activeDirectoryList: [],
            googleList: [],
            govBrList: [],
            billingList: [],
            loginTypeHasBeenCreated: false,
        };
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
        },
        manualShow: {
            type: Boolean,
            default: false,
        },
        noActivator: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.fetchIntegrations();
                this.fetchExternalServices();
                this.fetchActiveDirectory();
                this.fetchGoogle();
                this.fetchVouchers();
                this.fetchGovBr();
                this.fetchMercadoPago();
                if (this.isEdit) {
                    this.setInitialEditData();
                } else {
                    this.resetInitialData();
                }
            }
        },
        manualShow(showVal) {
            this.show = showVal;

            if (showVal && this.isEdit) {
                this.setInitialEditData();
            }
        },
        isFormTypeMac(val) {
            if (val) this.form.integrationId = undefined;
        },
    },

    computed: {
        isEdit() {
            return !!this.item;
        },
        actionLabel() {
            return this.isEdit
                ? this.$t("message.generics.message.save")
                : this.$t("message.generics.message.advance");
        },
        tabsWithoutExtraFields() {
            return [
                {
                    value: "GENERAL",
                    label: this.$t("message.generics.message.general"),
                    disabled: this.isGeneralTabDisabled,
                },
                {
                    value: "LOCALS",
                    label: this.$t("message.generics.message.spots"),
                    disabled: this.isLocalTabDisabled,
                },
            ];
        },
        tabsWithExtraFields() {
            return [
                {
                    value: "GENERAL",
                    label: this.$t("message.generics.message.general"),
                    disabled: this.isGeneralTabDisabled,
                },
                {
                    value: "LOCALS",
                    label: this.$t("message.generics.message.spots"),
                    disabled: this.isLocalTabDisabled,
                },
                {
                    value: "EXTRA-FIELDS",
                    label: this.$t("message.loginPersonalize.message.fields"),
                    disabled: this.isExtraFieldsTabDisabled,
                },
            ];
        },
        tabsWithoutGeneral() {
            return [
                {
                    value: "LOCALS",
                    label: this.$t("message.generics.message.spots"),
                    disabled: this.isLocalTabDisabled,
                },
                {
                    value: "EXTRA-FIELDS",
                    label: this.$t("message.loginPersonalize.message.fields"),
                    disabled: this.isExtraFieldsTabDisabled,
                },
            ];
        },
        tabs() {
            if (this.isTypeWithoutExtraFields) {
                return this.tabsWithoutExtraFields;
            }

            return this.isSocialLogin
                ? this.tabsWithoutGeneral
                : this.tabsWithExtraFields;
        },
        isTypeWithoutExtraFields() {
            return (
                this.form.type === "MAC" ||
                this.form.type === "EXTERNAL_SERVICE" ||
                this.form.type === "VOUCHER" ||
                this.form.type === "ACTIVE_DIRECTORY" ||
                this.form.type === "GOOGLE" ||
                this.form.type === "GOV_BR" ||
                this.form.type === "BILLING" ||
                !this.form.type
            );
        },
        isGeneralTab() {
            if (!this.tab) return false;

            return this.tab.value === "GENERAL";
        },
        isLocalsTab() {
            if (!this.tab) return false;

            return this.tab.value === "LOCALS";
        },
        isExtraFieldsTab() {
            if (!this.tab) return false;

            return this.tab.value === "EXTRA-FIELDS";
        },
        captiveLoginTypeId() {
            return this.isEdit ? this.item.id : this.form.id;
        },
        isSocialLogin() {
            let isSocialLogin = false;
            if (
                this.isEdit &&
                (this.item.type === "FACEBOOK" ||
                    this.item.type === "TWITTER" ||
                    this.item.type === "LINKEDIN")
            ) {
                isSocialLogin = true;
            }
            return isSocialLogin;
        },
        user() {
            return this.$store.state.users.user;
        },
        permissions() {
            return this.user.permissions;
        },
        canCreateCaptiveForm() {
            return this.permissions.find((x) => x === "ALLOW_MULTIPLE_LOGINS");
        },
        isFormTypeMac() {
            return this.form.type === "MAC";
        },
    },

    mounted() {
        this.tab = this.tabs[0];

        if (this.isEdit) {
            this.form = {
                id: this.item.id,
                name: this.item.name,
                loginButtonLabel: this.item.loginButtonLabel,
                isDefault: this.item.isDefault,
                integrationId: this.item.integrationId,
                externalServiceId: this.item.externalServiceId,
                segmentVoucherId: this.item.segmentVoucherId,
                type: this.item.type,
                locals: this.item.locals,
                timeoutUnit: this.item.timeoutUnit,
                timeoutValue: this.item.timeoutValue,
                isValidatePhoneNumber: this.item.isValidatePhoneNumber,
                isValidateEmail: this.item.isValidateEmail,
                vlan: this.item.vlan,
                ssidFilter: this.item.ssidFilter,
                allSsidSelected: this.item.allSsidSelected,
            };
        }
    },

    methods: {
        resetInitialData() {
            this.tab = this.tabs[0];
            this.form = {
                id: undefined,
                name: undefined,
                loginButtonLabel: undefined,
                type: undefined,
                integrationId: undefined,
                externalServiceId: undefined,
                segmentVoucherId: undefined,
                isDefault: false,
                locals: [],
                timeoutUnit: null,
                timeoutValue: undefined,
                isValidatePhoneNumber: false,
                isValidateEmail: false,
                vlan: undefined,
                ssidFilter: [],
                allSsidSelected: true,
            };
            this.loginTypeHasBeenCreated = false;
            this.isLocalTabDisabled = true;
            this.isExtraFieldsTabDisabled = true;
        },
        setInitialEditData() {
            this.isLocalTabDisabled = false;
            this.isExtraFieldsTabDisabled = false;
            this.form = {
                name: this.item.name,
                loginButtonLabel: this.item.loginButtonLabel,
                type: this.item.type,
                integrationId: this.item.integrationId,
                externalServiceId: this.item.externalServiceId,
                segmentVoucherId: this.item.segmentVoucherId,
                isDefault: this.item.isDefault,
                locals: this.item.locals,
                timeoutUnit: this.item.timeoutUnit,
                timeoutValue: this.item.timeoutValue,
                isValidatePhoneNumber: this.item.isValidatePhoneNumber,
                isValidateEmail: this.item.isValidateEmail,
                vlan: this.item.vlan,
                ssidFilter: this.item.ssidFilter,
                allSsidSelected: this.item.allSsidSelected,
            };
            this.$nextTick(() => (this.tab = this.tabs[0]));
        },
        onInput(isModalOpen) {
            if (isModalOpen !== this.manualShow) {
                if (isModalOpen) {
                    this.openModal();
                } else {
                    this.closeModal();
                }
            }
        },
        openModal() {
            if (this.manualShow) {
                this.$emit("update:manualShow", true);
            } else {
                this.show = true;
            }
        },
        closeModal() {
            if (this.manualShow) {
                this.$emit("update:manualShow", false);
            } else {
                this.show = false;
            }
        },
        emitBack() {
            this.$emit("back");
        },
        emitEdited() {
            this.$emit("edited");
        },
        emitAdded() {
            EventBus.$emit("CAPTIVE_FORM_ADDED");
        },
        emitInput(value) {
            this.$emit("input", value);
        },
        hideModal() {
            this.emitInput(false);
        },
        addLocal(node) {
            if (node.type === 1) {
                this.form.locals.push(node.objectId);
            }

            if (node.type === 0) {
                if (!node.children) {
                    return;
                } else {
                    node.children.map((childNode) => {
                        this.addLocal(childNode);
                    });
                }
            }
        },
        removeLocal(node) {
            if (node.type === 1) {
                const newLocals = this.form.locals.filter(
                    (localId) => localId !== node.objectId
                );
                this.form.locals = [...newLocals];
            }

            if (node.type === 0) {
                if (!node.children) {
                    return;
                } else {
                    node.children.map((childNode) => {
                        this.removeLocal(childNode);
                    });
                }
            }
        },

        removeLastChildren(locals) {
            for (const local of locals) {
                if (local.children.length > 0) {
                    this.removeLastChildren(local.children);
                } else {
                    local.children = undefined;
                }
            }

            return locals;
        },
        setIsOpenArray({ id, isOpen }) {
            if (isOpen) {
                const hasItem = this.isOpenArray.find((nodeId) => {
                    return id === nodeId;
                });

                if (!hasItem) {
                    this.isOpenArray.push(id);
                }
            } else {
                this.isOpenArray.filter((nodeId) => {
                    return nodeId === id;
                });
            }
        },
        validate() {
            this.$refs.body.validate();
        },
        validateForm() {
            try {
                if (!this.form.type)
                    throw this.$t(
                        "message.errorMessages.message.selectFieldType"
                    );
                if (
                    this.form.type === "EXTERNAL_SERVICE" &&
                    !this.form.externalServiceId
                )
                    throw this.$t(
                        "message.errorMessages.message.selectExternalService"
                    );
                if (
                    this.form.type === "ACTIVE_DIRECTORY" &&
                    !this.form.externalServiceId
                )
                    throw this.$t(
                        "message.errorMessages.message.selectExternalService"
                    );
                if (this.form.type === "VOUCHER" && !this.form.segmentVoucherId)
                    throw this.$t(
                        "message.errorMessages.message.selectVoucher"
                    );
                if (
                    this.form.timeoutUnit === "MINUTO" &&
                    this.form.timeoutValue < 15
                )
                    throw this.$t("message.errorMessages.message.timeoutValue");
                return {
                    valid: true,
                };
            } catch (error) {
                return {
                    valid: false,
                    message: error,
                };
            }
        },
        async save() {
            const isEdit = this.isEdit;

            if (!isEdit) {
                if (this.isGeneralTab) {
                    const response = this.validateForm();
                    if (!response.valid) {
                        return EventBus.$emit("show-message", {
                            type: "ERROR",
                            message: response.message,
                        });
                    }
                    if (!this.loginTypeHasBeenCreated) {
                        const loginType =
                            await this.$api.core.loginTypes.create({
                                name: this.form.name,
                                loginButtonLabel: this.form.loginButtonLabel,
                                type: this.form.type,
                                isDefault: this.isDefault,
                                integrationId: this.form.integrationId,
                                externalServiceId: this.form.externalServiceId,
                                segmentVoucherId: this.form.segmentVoucherId,
                                vlan: this.form.vlan,
                                ssidFilter: this.form.ssidFilter,
                                allSsidSelected: this.form.allSsidSelected,
                            });
                        this.form.id = loginType.id;
                        this.isLocalTabDisabled = false;
                        this.loginTypeHasBeenCreated = true;
                    } else {
                        await this.$api.core.loginTypes.edit({
                            id: this.form.id,
                            name: this.form.name,
                            loginButtonLabel: this.form.loginButtonLabel,
                            type: this.form.type,
                            isDefault: this.isDefault,
                            integrationId: this.form.integrationId,
                            externalServiceId: this.form.externalServiceId,
                            segmentVoucherId: this.form.segmentVoucherId,
                            timeoutUnit: this.form.timeoutUnit,
                            timeoutValue: this.form.timeoutValue,
                            isValidatePhoneNumber:
                                this.form.isValidatePhoneNumber,
                            isValidateEmail: this.form.isValidateEmail,
                            vlan: this.form.vlan,
                            ssidFilter: this.form.ssidFilter,
                            allSsidSelected: this.form.allSsidSelected,
                        });
                    }
                    this.tab = this.tabs[1];

                    this.locals = await this.$api.core.loginTypes.getLocalTree(
                        this.form.id
                    );
                    this.removeLastChildren(this.locals);
                } else if (this.isLocalsTab) {
                    await this.$api.core.loginTypes.edit({
                        id: this.form.id,
                        name: this.form.name,
                        loginButtonLabel: this.form.loginButtonLabel,
                        type: this.form.type,
                        integrationId: this.form.integrationId,
                        externalServiceId: this.form.externalServiceId,
                        segmentVoucherId: this.form.segmentVoucherId,
                        timeoutUnit: this.form.timeoutUnit,
                        timeoutValue: this.form.timeoutValue,
                        isDefault: this.isDefault,
                        locals: this.form.locals,
                        isValidatePhoneNumber: this.form.isValidatePhoneNumber,
                        isValidateEmail: this.form.isValidateEmail,
                        vlan: this.form.vlan,
                        ssidFilter: this.form.ssidFilter,
                        allSsidSelected: this.form.allSsidSelected,
                    });
                    if (this.isTypeWithoutExtraFields) {
                        this.resetInitialData();

                        EventBus.$emit("show-message", {
                            type: "SUCCESS",
                            message: this.$t(
                                "message.successMessages.message.formCreated"
                            ),
                            timeout: 2000,
                        });

                        this.emitAdded();
                        this.closeModal();
                        return;
                    }

                    this.isExtraFieldsTabDisabled = false;

                    this.tab = this.tabs[2];
                } else {
                    this.resetInitialData();

                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: this.$t(
                            "message.successMessages.message.formCreated"
                        ),
                        timeout: 2000,
                    });

                    this.emitAdded();
                    this.closeModal();
                }
            } else {
                const response = this.validateForm();
                if (!response.valid) {
                    return EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: response.message,
                    });
                }
                await this.$api.core.loginTypes.edit({
                    id: this.item.id,
                    name: this.form.name,
                    loginButtonLabel: this.form.loginButtonLabel,
                    type: this.form.type,
                    integrationId: this.form.integrationId,
                    externalServiceId: this.form.externalServiceId,
                    segmentVoucherId: this.form.segmentVoucherId,
                    timeoutUnit: this.form.timeoutUnit,
                    timeoutValue: this.form.timeoutValue,
                    isDefault: this.form.isDefault,
                    locals: this.form.locals,
                    isValidatePhoneNumber: this.form.isValidatePhoneNumber,
                    isValidateEmail: this.form.isValidateEmail,
                    vlan: this.form.vlan,
                    ssidFilter: this.form.ssidFilter,
                    allSsidSelected: this.form.allSsidSelected,
                });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t(
                        "message.successMessages.message.formEdited"
                    ),
                    timeout: 2000,
                });

                this.emitEdited();
                this.closeModal();
            }
        },
        setFormData(value) {
            this.form.name = value.name;
            this.form.loginButtonLabel = value.loginButtonLabel;
            this.form.type = value.type;
            this.form.isDefault = value.isDefault;
            this.form.integrationId = value.integrationId;
            this.form.externalServiceId = value.externalServiceId;
            this.form.segmentVoucherId = value.segmentVoucherId;
            this.form.timeoutUnit = value.timeoutUnit;
            this.form.timeoutValue = value.timeoutValue;
            this.form.ssidFilter = value.ssidFilter;
            this.form.allSsidSelected = value.allSsidSelected;
        },
        async fetchIntegrations() {
            try {
                this.integrationsList =
                    await this.$api.integrationManagement.listIntegrationsAccessExecution();
            } catch (error) {
                console.log(error);
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },
        async fetchExternalServices() {
            try {
                this.externalServicesList =
                    await this.$api.integrationManagement.listIntegrationsCaptiveLogin();
            } catch (error) {
                console.log(error);
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },

        async fetchGoogle() {
            try {
                this.googleList =
                    await this.$api.integrationManagement.listIntegrationsCaptiveLogin(
                        "GOOGLE"
                    );
            } catch (error) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },

        async fetchGovBr() {
            try {
                this.govBrList =
                    await this.$api.integrationManagement.listIntegrationsCaptiveLogin(
                        "GOV_BR"
                    );
            } catch (error) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },

        async fetchMercadoPago() {
            try {
                this.billingList =
                    await this.$api.integrationManagement.listIntegrationsCaptiveLogin(
                        "MERCADO_PAGO"
                    );
            } catch (error) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },

        async fetchActiveDirectory() {
            try {
                this.activeDirectoryList =
                    await this.$api.integrationManagement.listIntegrationsCaptiveLogin(
                        "AZURE_AD"
                    );
            } catch (error) {
                console.log(error);
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.integrationServiceUnavailable"
                    ),
                    timeout: 2000,
                });
            }
        },
        async fetchVouchers() {
            try {
                this.vouchersList = await this.$api.voucher.list();
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.login-type-add-form {
    .login-type-add-form-body {
        padding: 5px 20px 10px;

        .nav-tabs {
            margin-bottom: 30px;
        }

        .login-type-add-form-body-inputs {
            width: 60%;
            margin: 0 auto;
        }

        .login-type-add-form-body-actions {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
